import Calendar from './search-calendar'
import Time from './search-time'
import Area from './search-area'
import CarType from './search-cartype'
import SearchSubmit from './search-submit'
import OS from '../models/os'

class Search

  constructor: (elm) ->
    window.searchStory = []
    @$elm          = $ elm
    @$date         = @$elm.find '.js-date-day'
    @$dateTime     = @$elm.find '.js-date-time'
    @$area         = @$elm.find '.js-area-trigger'
    @$areaValue    = @$elm.find '.js-area'
    @$cartype      = @$elm.find '.js-cartype-trigger'
    @$cartypeValue = @$elm.find '.js-cartype'
    @time          = new Time @$dateTime, @$date, @$area
    @calendar      = new Calendar @$date, @$dateTime
    @area          = new Area @$area, @$areaValue
    @isMobile      = OS.getInstance().mobile
    @cartype       = new CarType @$cartype, @$cartypeValue, @isMobile
    @urlPath       = location.href

    new SearchSubmit @$elm, @isMobile

    # ベースタイム
    # window.baseTime = new Date '2018/5/31 18:46'
    window.baseTime = new Date()
    window.baseTime.setSeconds 0
    window.baseTime.setMilliseconds 0

    unless @urlPath.indexOf('sale30days') is -1
      @specialDateSpecification 30

    # 初期時刻を設定する
    if window.baseTime.getHours() >= 19
      # 翌日に繰越す
      window.baseTime.setDate window.baseTime.getDate() + 1
      window.baseTime.setHours 8
      window.baseTime.setMinutes 0
    else if window.baseTime.getHours() <= 8
      window.baseTime.setHours 8
      window.baseTime.setMinutes 0
    else
      # 当日予約可能
      window.baseTime.setMinutes @timeFormat window.baseTime.getMinutes()

    window.startTime = new Date window.baseTime.getTime()
    window.endTime   = new Date window.startTime.getTime()
    window.endTime.setMinutes window.startTime.getMinutes() + 60

    @init()

  init: =>
    # 初期日付時刻をSETする
    @calendar.init()
    @time.init()
    @area.init()
    @cartype.init()

  specialDateSpecification: (day) ->
    window.baseTime.setHours 0
    window.baseTime.setDate window.baseTime.getDate() + day
    window.baseTime.setMinutes 0

  timeFormat: (min) ->
    switch
      when min <= 15 then 30
      when min > 45 then 90
      else 60

export default Search



// WEBPACK FOOTER //
// ./webpack/imports/view/search.coffee